module.exports = __webpack_public_path__ + "img/mail.e2c6a30b.svg";